var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H10V27H8V19Z",
    fill: "#F4C343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H15V27H13V19Z",
    fill: "#F4C343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19H20V27H18V19Z",
    fill: "#F4C343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19H25V27H23V19Z",
    fill: "#F4C343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1051 10.5L25.1289 1H22.8711L27.8473 10.5H5.15269L10.1289 1H7.87113L2.89494 10.5H1.5V17.4667L4.1785 31H28.8198L31.5 17.599V10.5H30.1051ZM29.5 17.401L27.1802 29H5.8215L3.5 17.2708V17H29.5V17.401ZM29.5 15H3.5V12.5H29.5V15Z",
    fill: "#F4C343"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.2615a1c80a4803aaf792a39c01f8646d.svg";
export { ForwardRef as ReactComponent };